module.exports = __webpack_public_path__ + "static/img/gptModel72.90011d22.png";